<div class="details-body-wrapper">
  <app-service-offers-list [provider_id]="provider_id" [hideTitle]="false">
  </app-service-offers-list>
</div>
